import { Store } from 'react-notifications-component';

const _settings = {
	insert: 'top',
	container: 'top-right',
	animationIn: ['animate__animated', 'animate__zoomIn'],
	animationOut: ['animate__animated', 'animate__zoomOut'],
	dismiss: {
		duration: 5000,
	},
};

const showNotification = (title, message, type = 'default') => {
	Store.addNotification({
		title,
		message,
		type,
		..._settings,
	});
};

export default showNotification;
